import React, { useState, useEffect, useContext, useRef } from "react";
import { faCheck, faTimes, faInfoCircle } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useNavigate } from "react-router-dom";
import CheckoutContext from "../contexts/CheckoutContext";
import axios from "axios";
import LoadingSpinner from "./LoadingSpinner";

function SellerForm () {
    const navigate = useNavigate();

    const formRef = useRef(null);
    const { setSeller } = useContext(CheckoutContext);

    const [localSeller, setLocalSeller] = useState("");
    const [validLocalSeller, setValidLocalSeller] = useState(false);
    const [sellerUsers, setSellerUsers] = useState();
    const [loadingSellers, setLoadingSellers] = useState(true);

    const [errMsg, setErrMsg] = useState("");

    async function getSellers () {
        const response = await axios.get(`${process.env.REACT_APP_API_URL}user/seller`);
        setSellerUsers(response.data);
        setLoadingSellers(false);
        if (formRef.current) {
            formRef.current.scrollIntoView({ behavior: "smooth" });
        }
    }

    async function handleClickContinue (e) {
        e.preventDefault();
        // if button enabled with JS hack
        // const v1 = SELLER_REGEX.test(localSeller);

        if (localSeller === "Otro") {
            setValidLocalSeller(true); // "Otro" is valid
        } 
        else {
            const isValid = sellerUsers.some((seller) => seller.id == localSeller);
            if (!isValid) {
                setErrMsg("Invalid Entry");
                return;
            }
        }

        const data = {
            id: localSeller
        };

        setSeller(data);
        navigate("/checkout/info");
    };

    useEffect(() => {
        getSellers()
    }, []);

    useEffect(() => {
        if (localSeller === "Otro") {
            setValidLocalSeller(true); // "Otro" is valid
        } else {
            if (sellerUsers) {
                const isValid = sellerUsers.some((seller) => seller.id == localSeller);
                setValidLocalSeller(isValid);
            }
        }
        setErrMsg(''); // Clear error message
    }, [localSeller, sellerUsers]);

    if (loadingSellers) {
        return(
            <div className="text-center">
                <LoadingSpinner/>
            </div>
        )
    }
    else {
        return(
            <div ref={formRef} className="mx-3 bg-white border border-gray-100 rounded-2xl shadow-sm overflow-hidden mt-4">
                <div className="px-4 py-3 bg-[#fdf7ef] border-b border-gray-100 flex items-center gap-2">
                    <div className="w-7 h-7 rounded-full bg-[#0f4a4e] flex items-center justify-center flex-shrink-0">
                        <svg className="w-3.5 h-3.5 text-[#bcd4d2]" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                            <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"/><circle cx="12" cy="7" r="4"/>
                        </svg>
                    </div>
                    <p className="text-[14px] font-semibold text-[#1a1f1a]">¿Quién te envió el link?</p>
                </div>

                <form onSubmit={handleClickContinue} className="px-4 py-4 flex flex-col gap-4">

                    {errMsg && (
                        <div className="px-3 py-2 rounded-xl bg-red-50 border border-red-200 text-[12px] text-red-500 flex items-center gap-1.5">
                            <FontAwesomeIcon icon={faInfoCircle} />
                            {errMsg}
                        </div>
                    )}

                    <div className="flex flex-col gap-1.5">
                        <div className="flex items-center gap-1.5">
                            <label htmlFor="seller" className="text-[13px] font-medium text-[#1a1f1a]">Vendedor</label>
                            {validLocalSeller && <FontAwesomeIcon icon={faCheck} className="text-[#0f4a4e] text-[11px]" />}
                            {!validLocalSeller && localSeller && localSeller !== "selecciona" && <FontAwesomeIcon icon={faTimes} className="text-red-400 text-[11px]" />}
                        </div>
                        <select
                            id="seller"
                            autoComplete="off"
                            onChange={(e) => setLocalSeller(e.target.value)}
                            required
                            className={`w-full px-3 py-2.5 rounded-xl border bg-white outline-none transition-all text-[16px] text-[#1a1f1a] ${
                                validLocalSeller
                                    ? "border-[#0f4a4e] focus:border-[#0f4a4e] focus:ring-2 focus:ring-[#0f4a4e]/20"
                                    : "border-gray-200 focus:border-[#0f4a4e] focus:ring-2 focus:ring-[#0f4a4e]/20"
                            }`}
                        >
                            <option value="selecciona">Seleccionar vendedor…</option>
                            {sellerUsers.map((seller, index) => (
                                <option key={index} value={seller.id}>{seller.firstName} {seller.lastName}</option>
                            ))}
                            <option value="Otro">Otro</option>
                        </select>
                        {localSeller && localSeller !== "selecciona" && !validLocalSeller && (
                            <p className="text-[11px] text-red-500 flex items-center gap-1">
                                <FontAwesomeIcon icon={faInfoCircle} />
                                Selecciona una opción válida
                            </p>
                        )}
                    </div>

                    <button
                        type="submit"
                        disabled={!validLocalSeller}
                        className={`w-full py-3 rounded-xl text-[14px] font-bold transition-colors ${
                            validLocalSeller
                                ? "bg-[#0f4a4e] hover:bg-[#155e63] text-[#fdf7ef]"
                                : "bg-gray-100 text-gray-300 cursor-not-allowed"
                        }`}
                    >
                        Continuar
                    </button>
                </form>
            </div>
        )
    }
}

export default SellerForm;